<template>
  <div class="landing">
    <section>
      <h1>Start building an app from your own custom template.</h1>
      <h4>Choose your framework. Choose your architecture. Define your views and generate a custom code skeleton.</h4>
      <div>
        <button @click="getStarted()">Get started</button>
        <p>This is an MVP. Public sign ups open for a limited time only*</p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  name: "Landing",
  mounted() {
    this.UPDATE_NAVIGATION_BAR_STATE(0);
    this.setFooterState(0);
  },
  methods: {
    ...mapMutations(['UPDATE_NAVIGATION_BAR_STATE']),
    ...mapActions(['setFooterState']),
    getStarted() {
      this.$router.push("login");
    },
    signUp() {
      this.$router.push("signup");
    }
  }
};
</script>

<style lang="scss">
@import "../assets/styles/styles.scss";

.landing {
  display: grid;
}

section {
  height: fit-content;
  width: 70%;
  justify-self: center;
  align-self: center;
  display: grid;
  grid-template-rows: 200px 200px 100px;
  grid-template-areas:
    "heading"
    "subheading"
    "callToAction";

  h1,
  h4 {
    text-align: center;
    justify-self: center;
  }

  h1 {
    grid-area: heading;
    line-height: 60px;
    align-self: end;
  }

  h4 {
    grid-area: subheading;
    margin-top: 40px;
    width: 80%;
  }

  div {
    justify-self: center;
    grid-area: callToAction;

    display: grid;
    grid-template-rows: 50px 50px;

    button {
      justify-self: center;
      height: fit-content;
    }

    p {
      font-size: 0.8em;
    }
  }
}
</style>
